import { useEffect, useRef, useState } from "react";
import { IconButton, Slider } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { PauseCircle } from "@mui/icons-material";
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import styled from 'styled-components';
import './style.scss';
import { CgAddR } from "react-icons/cg";

const CustomStyledMediaDownloadProgress = styled(Slider)({
    '& .MuiSlider-thumb': {
        width: '0', height: '0',
        backgroundColor: '#FF4500',
    },
    '& .MuiSlider-track': {
        backgroundColor: '#6444fe',
    },
    '& .MuiSlider-rail': {
        backgroundColor: '#F7931A',
    },
    height: '25%',
    padding: '0 0',
    margin: '0'
});

const CustomStyle = styled(Slider)({
    '& .MuiSlider-thumb': {
        width: '50', height: '50',
        backgroundColor: '#FF4500',
    },
    '& .MuiSlider-track': {
        backgroundColor: '#FFA500',
    },
    '& .MuiSlider-rail': {
        backgroundColor: '#F7931A',
    },
    height: '25%',
    padding: '0 0',
    margin: '0'
});

const Attachments = ({
    index, txId,
    type: { imageType, audioType, videoType },
    content,
    attachmentUrl, thumbnailUrl,
    ChimeAuthorPrincipal,

    playList, setPlayList, mediaCurrentTime,
    selectedChimeTx, setSelectedChimeTx,
    openMediaPlayer, setOpenMediaPlayer,

    replyCounts, replied,
    likeCounts, liked,
    disLikeCounts, disliked,
}) => {
    const [fullScreen, setFullScreen] = useState(false);
    const [position, setPosition] = useState(0);
    const [duration, setDuration] = useState(0);
    const [mute, setMute] = useState(null);
    const [playorPaused, setPlayorPaused] = useState(false);
    const [posterKey, setPosterKey] = useState(0);
    const [videoDimension, setVideoDimension] = useState({ width: '', height: '' });

    const [mediaWaiting, setMediaWaiting] = useState(false);
    const [errorCount, setErrorCount] = useState(0);
    const [blobUrl, setBlobUrl] = useState(null);
    const [blodDownloadProgress, setBlobDownloadProgress] = useState(0);
    const [partialBlobUrl, setPartialBlobUrl] = useState([]);
    const [nextChunkIndex, setNextChunkIndex] = useState(0);

    const vidRef = useRef(null);
    const playerArea = useRef(null);

    // const mediaSourceRef = useRef(null);
    // const sourceBufferRef = useRef(null);
    // useEffect(() => {
    //     const vidElement = vidRef.current;
    //     const mediaSource = new MediaSource();
    //     mediaSourceRef.current = mediaSource;

    //     vidElement.src = URL.createObjectURL(mediaSource);
    //     function handleSourceOpen() {
    //         const mediaSource = mediaSourceRef.current;
    //         let mimeCodec;
    //         if (videoType) {
    //             mimeCodec = 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"';
    //         } else {
    //             mimeCodec = 'audio/mpeg';
    //         }

    //         if (mediaSource && mediaSource.readyState === 'open') {
    //             try {
    //                 const sourceBuffer = mediaSource.addSourceBuffer(mimeCodec);
    //                 sourceBufferRef.current = sourceBuffer;

    //                 sourceBuffer.addEventListener('updateend', handleUpdateEnd);
    //             } catch (error) {
    //                 console.error('Error adding source buffer:', error);
    //             }
    //         }
    //         setDuration(parseInt(vidElement.duration));
    //         if (!duration) console.log({ vidElement, mediaSource });
    //     };

    //     function handleLoadedMetadata() {
    //         setDuration(parseInt(vidElement.duration));
    //         setVideoDimension({ width: vidElement.videoWidth, height: vidElement.videoHeight });
    //     }

    //     vidElement.removeEventListener('loadedmetadata', handleLoadedMetadata);
    //     mediaSource.addEventListener('sourceopen', handleSourceOpen);

    //     return () => {
    //         vidElement.removeEventListener('loadedmetadata', handleLoadedMetadata);
    //         mediaSource.removeEventListener('sourceopen', handleSourceOpen);
    //     };
    // }, []);

    // useEffect(() => {
    //     if (sourceBufferRef.current && partialBlobUrl.length > 0) {
    //         appendNextChunk();
    //     }
    // }, [partialBlobUrl]);

    // const appendNextChunk = () => {
    //     const sourceBuffer = sourceBufferRef.current;
    //     if (sourceBuffer && !sourceBuffer.updating && partialBlobUrl.length - 1 >= nextChunkIndex) {
    //         const nextChunk = partialBlobUrl[nextChunkIndex];
    //         sourceBuffer.appendBuffer(nextChunk);
    //         setNextChunkIndex(prev => prev + 1);
    //     }
    // };

    // const handleUpdateEnd = () => {
    //     if (partialBlobUrl.length - 1 >= nextChunkIndex) {
    //         appendNextChunk();
    //     }

    //     if (partialBlobUrl.length === 0 && mediaSourceRef.current.readyState === 'open') {
    //         mediaSourceRef.current.endOfStream();
    //     }
    //     console.log('Update ended, appended next chunk or ended stream.');
    // };

    // Media player States Trackers +============================>>>>>>>>>>>>>>
    
    // Duration, Playtime and Stall/Correct Handler
    useEffect(() => {
        const vidElement = vidRef.current;
        if (!vidElement) return;

        function handleWaiting(e) {
            console.log({ event: 'waiting', e });
            setMediaWaiting(true);
        };

        function handleLoadedMetadata(e) {
            setDuration(vidElement.duration);
        }

        function handlePlaying() {
            if ((selectedChimeTx !== index) && playorPaused) {
                vidElement.pause()?.catch(error => { console.error('Error paused video:', { index }); });
                console.log('+============================>>>>>>>>>>>>>>>>>>>>><<<<<<<<<<<<<<<<<<', { index, selectedChimeTx, playorPaused });
            }
        }

        function handleError(e) {
            console.error('Vid Elemen crashed', { e });
        };

        function handleTimeUpdate() {
            setPosition(vidElement.currentTime);
        };



        // Add Event Listeners
        vidElement.addEventListener('loadedmetadata', handleLoadedMetadata);
        vidElement.addEventListener('waiting', handleWaiting);
        // vidElement.addEventListener('canplay', handleCanPlay);
        vidElement.addEventListener('playing', handlePlaying);
        vidElement.addEventListener('error', handleError);
        vidElement.addEventListener('timeupdate', handleTimeUpdate);

        // Cleanup event listeners on component unmount
        return () => {
            vidElement.removeEventListener('loadedmetadata', handleLoadedMetadata);
            vidElement.removeEventListener('waiting', handleWaiting);
            // vidElement.removeEventListener('canplay', handleCanPlay);
            vidElement.removeEventListener('playing', handlePlaying);
            vidElement.removeEventListener('error', handleError);
            vidElement.removeEventListener('timeupdate', handleTimeUpdate);

        };
    }, [mediaWaiting, attachmentUrl, selectedChimeTx, playorPaused]);

    // Handles Play Pause displays
    useEffect(() => {
        const vidElement = vidRef.current;
        if (!vidElement) return;

        function onPlay() { setPlayorPaused(true) };
        function onPause() { setPlayorPaused(false) };

        vidElement.addEventListener('play', onPlay);
        vidElement.addEventListener('pause', onPause);
        return () => {
            vidElement.removeEventListener('play', onPlay);
            vidElement.removeEventListener('pause', onPause);
        }
    }, [])

    // Tracking Mute or Ummute
    useEffect(() => {
        const vidElement = vidRef.current;
        if (!vidElement) return;

        const handleVolumeChange = () => { setMute(vidElement.muted) };
        vidElement.addEventListener('volumechange', handleVolumeChange);
        // Cleanup event listener on component unmount
        return () => {
            vidElement.removeEventListener('volumechange', handleVolumeChange);
        };
    }, []);

    // Fullscreen handler =====>>>
    useEffect(() => {
        const vidElement = vidRef.current;
        if (!vidElement) return;

        function onFullscreenChange() {
            if (!fullScreen) {
                if (vidElement.fullscreenElement) {
                    vidElement.exitFullscreen();
                } else if (vidElement.mozFullScreenElement) { /* Firefox */
                    vidElement.mozCancelFullScreen();
                } else if (vidElement.webkitFullscreenElement) { /* Chrome, Safari and Opera */
                    vidElement.webkitExitFullscreen();
                } else if (vidElement.msFullscreenElement) { /* IE/Edge */
                    vidElement.msExitFullscreen();
                }
            }
            setFullScreen(!fullScreen);
        }

        // Listeners
        vidElement.addEventListener('fullscreenchange', onFullscreenChange);
        vidElement.addEventListener('mozfullscreenchange', onFullscreenChange);
        vidElement.addEventListener('webkitfullscreenchange', onFullscreenChange);
        vidElement.addEventListener('msfullscreenchange', onFullscreenChange);
        // Cleanup
        return () => {
            vidElement.removeEventListener('fullscreenchange', onFullscreenChange);
            vidElement.removeEventListener('mozfullscreenchange', onFullscreenChange);
            vidElement.removeEventListener('webkitfullscreenchange', onFullscreenChange);
            vidElement.removeEventListener('msfullscreenchange', onFullscreenChange);
        };
    }, [fullScreen]);

        // Tracking if Attachment Element is in View or Not
        useEffect(() => {
            const vidElement = vidRef.current;
            if (!vidElement) return;
    
            const observerCallback = (entries) => {
                entries.forEach(entry => {
                    if (entry?.isIntersecting) {
                        if ((selectedChimeTx === index) && openMediaPlayer) setOpenMediaPlayer(false);
                    } else if (!entry?.isIntersecting) {
                        if ((selectedChimeTx === index) && !openMediaPlayer) {
                            if (playorPaused) vidElement.pause();
                            addToPlayList()
                            setOpenMediaPlayer(true);
                        }
                    }
                });
            };
            const observerOptions = { root: null, threshold: 1 };
            const observer = new IntersectionObserver(observerCallback, observerOptions);
            observer.observe(vidElement);
            // Cleanup on component unmount
            return () => {
                observer.unobserve(vidElement);
            };
        }, [selectedChimeTx, openMediaPlayer, playorPaused]);
    
        // Track Resume of Media from Snackbar Player to Attachment Player
        useEffect(() => {
            const vidElement = vidRef.current;
            if (!vidElement) return;
    
    
            const { currentTime, playorPaused: snackMediaPlayPaused, index: snackPlayerIndex } = mediaCurrentTime;
            if (snackPlayerIndex === index && !openMediaPlayer) {
                vidElement.currentTime = currentTime;
                if (snackMediaPlayPaused) vidElement.play();
                if (!snackMediaPlayPaused) vidElement.pause();
            }
        }, [mediaCurrentTime])
    
        // ==========================================<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
        // Attachment Media Player Functions ==========>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    
        // function delay(ms) {
        //     return new Promise(resolve => setTimeout(resolve, ms));
        // }
        // Construct url to byte           
        const downloadVideo = async () => {
            const vidElement = vidRef.current;
            if (!vidElement) return;
    
            setMediaWaiting(true);
    
            try {
                const response = await fetch(attachmentUrl);
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
    
                const contentLength = response.headers.get('Content-Length');
                if (!contentLength) {
                    throw new Error('Content-Length response header unavailable');
                }
    
                const total = parseInt(contentLength, 10);
                let loaded = 0;
                console.log('check this', { response });
                const reader = response.body.getReader();
                // new ReadableStream({
                //     start(controller) {
                //         function push() {
                //             reader.read().then(async ({ done, value }) => {
                //                 if (done) {
                //                     controller.close();
                //                     return;
                //                 }
                //                 loaded += value.byteLength;
    
                //                 const halfBlob = new Blob([value], { type: videoType ? "video/mp4" : "audio/mp3" });
                //                 const halfBlobUrl = URL.createObjectURL(halfBlob);
                //                 const progressCompleted = Math.round((loaded / total) * 100);
                //                 setBlobDownloadProgress(progressCompleted);
                //                 setPartialBlobUrl(prev => [...prev, value]);
                //                 await delay(2000); // 2000 milliseconds (2 seconds) delay
                //                 push();
                //             }).catch(error => {
                //                 console.error('Stream read error:', error);
                //                 controller.error(error);
                //             });
                //         }
                //         push();
                //     }
                // });
                const stream = new ReadableStream({
                    start(controller) {
                        function push() {
                            reader.read().then(({ done, value }) => {
                                if (done) {
                                    controller.close();
                                    return;
                                }
                                loaded += value.byteLength;
                                setBlobDownloadProgress(Math.round((loaded / total) * 100));
                                controller.enqueue(value);
                                push();
                            }).catch(error => {
                                console.error('Stream read error:', error);
                                controller.error(error);
                            });
                        }
                        push();
                    }
                });
    
    
                const newResponse = new Response(stream);
                const buffer = await newResponse.arrayBuffer();
                const byteArray = new Uint8Array(buffer);
    
                // Create a Blob from the byte array and generate a URL for the video element
                const blob = new Blob([byteArray], { type: videoType ? "video/mp4" : "audio/mp3" });
                console.log({ new: 'here', blob });
                const blobUrl = URL.createObjectURL(blob);
    
                // // Set the video element's source to the Blob URL
                vidElement.src = blobUrl;
                vidElement.load();
                setBlobUrl(blobUrl);
                return blobUrl;
            } catch (error) {
                console.error('Error downloading video:', error);
            } finally {
                setMediaWaiting(false);
            }
        };
    
        // Adding to playlist
        async function addToPlayList() {
            const vidElement = vidRef.current;
            if (!vidElement) return;
    
            let url;
            if (!blobUrl) url = await downloadVideo();
    
            setPlayList(prev => {
                // Check if txId already exists in the playlist
                const exists = prev.some(item => (item.index === index) || (item.txId === txId));
                if (exists) {
                    // Update the existing entry
                    return prev.map(item =>
                        (item.index === index) || (item.txId === txId)
                            ? {
                                ...item,
                                index, txId, content,
                                attachment_url: blobUrl || url,
                                thumbnail_url: thumbnailUrl,
                                ChimeAuthorPrincipal,
                                playorPaused,
                                currentTime: item.currentTime > vidElement.currentTime ? item.currentTime : vidElement.currentTime,
                                videoType,
                                replyCounts, replied,
                                likeCounts, liked,
                                disLikeCounts, disliked
                            }
                            : item
                    );
                } else {
                    // Add a new entry
                    return [
                        ...prev,
                        {
                            index, txId, content,
                            attachment_url: blobUrl || url,
                            thumbnail_url: thumbnailUrl,
                            ChimeAuthorPrincipal,
                            playorPaused,
                            currentTime: vidRef.current.currentTime,
                            videoType,
                            replyCounts, replied,
                            likeCounts, liked,
                            disLikeCounts, disliked
                        }
                    ];
                }
            });
        };
    
        // Handles media seeking
        function seek(value) {
            if (!vidRef) return;
            setPosition(value);
            vidRef.current.currentTime = value;
        }
    
        // Handles play/pause
        async function handlePlayOrPause() {
            const vidElement = vidRef.current;
            if (!vidElement) return;
    
            setMediaWaiting(true);
            if (!playorPaused) {
                setSelectedChimeTx(index);
                if (!blobUrl) await downloadVideo();
                vidElement.play()?.catch(error => { console.error('Error playing video:', { index }); });
            } else {
                vidElement.pause()?.catch(error => { console.error('Error paused video:', { index }); });
            }
        }
    
        // Handles mute and unmute
        function handleMuteOrUnmuted() {
            if (!vidRef) return;
            vidRef.current.muted = !vidRef.current.muted;
        }
    
        function handleFullScreen() {
            const vidElement = vidRef.current;
            if (!vidElement) return;
    
            if (vidElement.requestFullscreen) {
                vidElement.requestFullscreen();
            } else if (vidElement.mozRequestFullScreen) { /* Firefox */
                vidElement.mozRequestFullScreen();
            } else if (vidElement.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
                vidElement.webkitRequestFullscreen();
            } else if (vidElement.msRequestFullscreen) { /* IE/Edge */
                vidElement.msRequestFullscreen();
            }
        }
    
        function handleVideoEnded() {
            const vidElement = vidRef.current;
            if (!vidElement) return;
    
            // vidElement.currentTime = 0;
            setPosterKey(prevKey => prevKey + 1);
        }
    
        // Media play time
        function formatDuration(value) {
            const minute = Math.floor(value / 60);
            const secondLeft = Math.floor(value - minute * 60);
            return `${minute}:${secondLeft < 10 ? `0${secondLeft}` : secondLeft}`;
        }
    // Rest of your code...

    return (
        <div className="attachmentContainer" ref={playerArea}>
            <div className="main-media-wrapper">
                {imageType ? (
                    <img
                        src={attachmentUrl}
                        alt="Attachment"
                        style={{ width: '100%', height: 'auto' }}
                    />
                ) : (
                    <video className="main-media-player"
                        ref={vidRef}
                        preload="auto"
                        poster={imageType ? attachmentUrl : thumbnailUrl + `?${posterKey}`}
                        onEnded={handleVideoEnded}
                        controls={false}
                        style={{ zIndex: 0 }}
                    >
                        <source src={(videoType || audioType) ? blobUrl : attachmentUrl} type={videoType ? "video/mp4" : "audio/mp3"} />
                    </video>
                )}

                {/* {(videoType && blobUrl) &&
                    <div className="main-media-resolution">
                        Dimension: <small>{`${videoDimension?.width} x ${videoDimension?.height}`}</small>
                    </div>
                } */}
                
                {(videoType || audioType) &&
                    <div className="sliderContainer">
                        <div className="sliders-overlap">
                            <div className="diva"><CustomStyledMediaDownloadProgress variant="determinate" value={blodDownloadProgress} sx={{ color: 'red' }} /></div>
                            <div className="divb"><CustomStyle className="slider" size="small" defaultValue={0} aria-label="Small" valueLabelDisplay="auto" valueLabelFormat={formatDuration(position)} onChange={(_, value) => seek(value)} value={position} min={0} step={1} max={blodDownloadProgress === 100 ? duration : 300} /></div>
                        </div>
                    </div>
                }
            </div>

            {(videoType || audioType) &&
                <div className="main-media-control">

                    <div className="main-control-button">
                        <IconButton aria-label="play/pause"
                            onMouseDown={handlePlayOrPause}
                        >
                            {playorPaused ? <PauseCircle sx={{ height: 35, width: 35, color: "#fff" }} /> : <PlayArrowIcon sx={{ height: 35, width: 35, color: "#fff" }} />}
                        </IconButton>
                    </div>

                    <div className="main-control-button">
                        <IconButton aria-label="play/pause"
                            onMouseDown={handleMuteOrUnmuted}
                        >
                            {mute ? <VolumeOffIcon sx={{ height: 35, width: 35, color: "#fff" }} /> : <VolumeUpIcon sx={{ height: 35, width: 35, color: "#fff" }} />}
                        </IconButton>
                    </div>

                    <div className="main-control-button">
                        <IconButton aria-label="play/pause"
                            onMouseDown={handleFullScreen}
                        >
                            {fullScreen ? <FullscreenExitIcon sx={{ height: 35, width: 35, color: "#fff" }} /> : <FullscreenIcon sx={{ height: 35, width: 35, color: "#fff" }} />}
                        </IconButton>
                    </div>

                    <div className="main-control-button">
                        <div className="main-media-duration-wrap">
                            <div className="duration">
                                {(formatDuration(position))} / {(formatDuration(duration) === 'NaN:NaN' ? '00:00' : formatDuration(duration))}
                            </div>
                        </div>
                    </div>

                    <div className="main-control-button">
                        <IconButton aria-label="play/pause"
                            onMouseDown={addToPlayList}
                        >
                            <CgAddR color="#fff" style={{ height: 35, width: 35, color: "#fff" }} />
                        </IconButton>
                    </div>
                </div>
            }

        </div>
    );
}

export default Attachments;